import { createRouter, createWebHistory } from "vue-router";

import routerPC from './router_pc';
import routerMobile from './router_mobile';
import store from './store/index.js';
const router = createRouter({
    history: createWebHistory(),
    routes: [
        ...routerPC,...routerMobile   
    ],
    scrollBehavior(_, _2, savedPosition) {
        //console.log(to, from, savedPosition)
        if (savedPosition) {
            return savedPosition
        }
        return { left: 0, top: 0 }
    }
});

// router.beforeEach(function (to, from, next) {
//     console.log('Global beforeEach')
//     console.log(to, from, next)
//     if (to.meta.needsAuth) {
//         console.log('Needs auth!')
//         next()
//     } else {
//         next()
//     }
//     // if ( to.name === 'team-members'){
//     //     next()
//     // }else{
//     //     next({name:'team-members', params:{teamId:'t2'}})
//     // }
//     next()
// })
router.beforeEach(function(to, _, next) {
    //로그인 유지를 위한 만료 갱신
    store.dispatch("refreshExpire");
    if ( (to.meta.requiresAuth || to.meta.requiresAuthMobile) && !store.getters.isAuthenticated) {
      if(to.meta.requiresAuthMobile)
      {
        next({name:'m_Login', params:{prevroute:to.name, path:to.path}})
      }else{
        next({name:'auth_login', params:{prevroute:to.name, path:to.path}})
      }
      
    } else if ( (to.meta.requiresUnauth || to.meta.requiresUnauthMobile )&& store.getters.isAuthenticated) {
      if(to.meta.requiresUnauthMobile)
      {
        next({name:'m_Main'});
      }else{
        next('/home');
      }
      
    } else {
      next();
    }
  });
router.afterEach(function (to, from) {
    //sending analytics data
    // if(to.fullpath == from.fullpath)
    // {

    // }
    console.log('Global afterEach')
    console.log(to, from)
})

export default router;
